import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=09bc0ce2&scoped=true&"
import script from "./reset.js?vue&type=script&lang=js&"
export * from "./reset.js?vue&type=script&lang=js&"
import style0 from "./reset.vue?vue&type=style&index=0&id=09bc0ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc0ce2",
  null
  
)

export default component.exports